import { getPath } from '@/router/common'

const baseUrl = {
  title: '运营考核',
  path: 'OP'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'indexOp',
    component: () => import(/* webpackChunkName: "indexOp" */ '@/views/oP/index/index.vue'),
    meta: {
      title: '运营考核'
    }
  },
  {
    path: getPath('OperationRecord', baseUrl),
    name: 'OperationRecordOp',
    component: () => import(/* webpackChunkName: "OperationRecord" */ '@/views/oP/operationRecord/index.vue'),
    meta: {
      title: '新增编辑运营记录'
    }
  },
  {
    path: getPath('ImportRecord', baseUrl),
    name: 'ImportRecordOp',
    component: () => import(/* webpackChunkName: "ImportRecord" */ '@/views/oP/importRecord/index.vue'),
    meta: {
      title: '运营考核记录导入'
    }
  },
  {
    path: getPath('ImportIndex', baseUrl),
    name: 'ImportIndexOp',
    component: () => import(/* webpackChunkName: "ImportIndex" */ '@/views/oP/importIndex/index.vue'),
    meta: {
      title: '导入运营考核记录'
    }
  },
  {
    path: getPath('ImportDetails', baseUrl),
    name: 'ImportDetailsOp',
    component: () => import(/* webpackChunkName: "ImportDetails" */ '@/views/oP/importDetails/index.vue'),
    meta: {
      title: '导入运营考核记录明细'
    }
  },
  {
      path: getPath('OPTemplate', baseUrl),
      name: 'OP_OPTemplate',
      component: () => import(/* webpackChunkName: "OP_OPTemplate" */ '@/views/oP/oPTemplate/index.vue'),
      meta: {
        title: '运营考核导入模板管理'
      }
  },
  {
      path: getPath('OPTemplateEdit', baseUrl),
      name: 'OP_OPTemplateEdit',
      component: () => import(/* webpackChunkName: "OP_OPTemplateEdit" */ '@/views/oP/oPTemplateEdit/index.vue'),
      meta: {
        title: '运营考核修改'
      }
  }
]

